import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

import DashboardWrap from '@/views/DashboardWrap.vue'
import DashboardHome from '@/views/DashboardHome.vue'

import MyTransporterOffersList from '@/views/Offers/Transporter/MyList.vue'
import TransporterOffersCreate from '@/views/Offers/Transporter/CreateView.vue'
import TransporterOffersActive from '@/views/Offers/Transporter/ActiveView.vue'

import MyPassengerOffersList from '@/views/Offers/Passenger/MyList.vue'
import PassengerOffersCreate from '@/views/Offers/Passenger/CreateView.vue'
import PassengerOffersActive from '@/views/Offers/Passenger/ActiveView.vue'

import AccountView from '@/views/User/AccountView.vue'
import LoginView from '@/views/User/LoginView.vue'
import RegisterView from '@/views/User/RegisterView.vue'

const routes = [
  { 
    path: '',
    component: DashboardWrap,
    // redirect: { path: "/offers/transporter/active" },
    children: [
      { // Login
        path: '/login',
        name: 'Login',
        component: LoginView,
        meta: {
            title: 'login_page_title'
        }
      },
      { // Register
        path: '/register',
        name: 'Register',
        component: RegisterView,
        meta: {
            title: 'register_page_title'
        }
      },
      {
        path: '/',
        name: 'Home',
        component: DashboardHome,
        meta: {
            title: 'home_page_title'
        }
      },
      {
        path: '/offers/transporter/my',
        name: 'MyTransporterOffers',
        component: MyTransporterOffersList,
        meta: {
            requires_user: true,
            title: 'my_offers_page_title'
        }
      },
      {
        path: '/offers/transporter/create',
        name: 'TransporterOffersCreate',
        component: TransporterOffersCreate,
        meta: {
            requires_user: true,
            requires_role: 'transporter',
            title: 'offers_create_page_title'
        }
      },
      {
        path: '/offers/transporter/active',
        name: 'TransporterOffersActive',
        component: TransporterOffersActive,
        meta: {
            title: 'transporter_offers_active_page_title'
        }
      },
      
      {
        path: '/offers/passenger/my',
        name: 'MyPassengerOffers',
        component: MyPassengerOffersList,
        meta: {
            requires_user: true,
            title: 'my_offers_page_title'
        }
      },
      {
        path: '/offers/passenger/create',
        name: 'PassengerOffersCreate',
        component: PassengerOffersCreate,
        meta: {
            requires_user: true,
            requires_role: 'passenger',
            title: 'offers_create_page_title'
        }
      },
      {
        path: '/offers/passenger/active',
        name: 'PassengerOffersActive',
        component: PassengerOffersActive,
        meta: {
            title: 'passenger_offers_active_page_title'
        }
      },
      {
        path: '/account',
        name: 'Account',
        component: AccountView,
        meta: {
            requires_user: true,
            title: 'account_page_title'
        }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

import Locales from '@/mixins/Locales'

router.beforeEach(async (to, from, next) => {
    const title = Locales.methods.loc(to.meta.title) + ' | SultanTaxi'
    if (title) { document.title =  title}

    const hasToken = store.getters.hasToken
    if(hasToken !== undefined){
        store.dispatch('getUser')
        if(to.name === 'Login' || to.name === 'Register' || to.name === undefined){
          return next({ name: 'Home' })          
        }
                
        // if (store.state.user?.role === undefined || store.state.user.role !== to.meta.requires_role) {
        //   return next({ name: 'Home' })
        // }

        return next()
    } 
    else {
        // if (to.meta.requires_user === true) {
        //   return next({ name: 'Login' })
        // } else {
          return next()
        // }
    }
})

export default router
